//  poviciService.js (API верзија - база)

// import axios from "axios";
import api from "@/api";

// const API_BASE = "https://nalozi.megasoft.com.mk/api";

const ENDPOINTS = {
  GET: "/povici/get",
  SAVE: "/povici/save",
  DELETE: (id) => `/povici/delete/${id}`,
  UPDATE: (id) => `/povici/update/${id}`,
  STATUS: (id) => `/povici/status/${id}`,
  BARANJE: (id) => `/povici/baranje/${id}`
};

// helper
function pick(obj, keys, fallback = undefined) {
  for (const k of keys) {
    if (obj && obj[k] !== undefined && obj[k] !== null) return obj[k];
  }
  return fallback;
}

function toNumberOrNull(v) {
  if (v === undefined || v === null || v === "") return null;
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
}


//  GET – сите повици
export async function getSitePovici(params = {}) {
  // const res = await axios.get(ENDPOINTS.GET, { params });
  const res = await api.get(ENDPOINTS.GET, { params });

  if (Array.isArray(res.data)) return res.data;

  return (
    res.data?.Items ||
    res.data?.items ||
    res.data?.List ||
    res.data?.list ||
    []
  );
}

//  SAVE – СНИМАЊЕ ПОВЕЌЕ ПОВИЦИ (Items)
export async function savePovici(poviciArray) {
  if (!Array.isArray(poviciArray) || poviciArray.length === 0) {
    throw new Error("No phone calls provided.");
  }

  const Items = poviciArray.map(p => ({
    Datum: pick(p, ["Datum", "datum"], new Date().toISOString()),
    Baral: pick(p, ["Baral", "baral", "klient"], ""),
    PartnerID: pick(p, ["PartnerID", "firma"]),
    BaralVrabID: pick(p, ["BaralVrabID", "baralVrabID"], null),
    Opis: pick(p, ["Opis", "opis"], ""),
    Prosledeno: !!pick(p, ["Prosledeno", "prosledeno", "prosleden"], false),
    VrabID: pick(p, ["VrabID", "vraboten"]),
    Baranje: toNumberOrNull(pick(p, ["Baranje", "brojNalog"]))
  }));

  const payload = { Items };

  console.log(" SAVE /povici/save payload:", payload);

  // const res = await axios.post(ENDPOINTS.SAVE, payload, {
    const res = await api.post(ENDPOINTS.SAVE, payload, {
    headers: { "Content-Type": "application/json" }
  });

  return res.data;
}

//  DELETE
export async function izbrisiPovik(id) {
  // const res = await axios.delete(ENDPOINTS.DELETE(id));
  const res = await api.delete(ENDPOINTS.DELETE(id));
  return res.data;
}

// PATCH STATUS
export async function azurirajPovikStatus(id, prosledeno) {
  // const res = await axios.patch(
    const res = await api.patch(
    ENDPOINTS.STATUS(id),
    { Prosledeno: !!prosledeno },
    { headers: { "Content-Type": "application/json" } }
  );
  return res.data;
}

//  UPDATE POVIK
export async function azurirajPovik(id, patch) {
  const res = await api.put(ENDPOINTS.UPDATE(id), patch, {
    headers: { "Content-Type": "application/json" }
  });
  return res.data;
}

//  UPDATE BARANJE
export async function postaviBrojNalogZaPovik(povikId, brojNalog) {
  const payload = { Baranje: toNumberOrNull(brojNalog) };

  try {
    const res = await api.patch(ENDPOINTS.BARANJE(povikId), payload);
    return res.data;
  } catch {
    const res2 = await api.put(ENDPOINTS.UPDATE(povikId), payload);
    return res2.data;
  }
}
